import { post } from '.';

export function CreateQuickReply(options = {}) {
	return post<any>("/app/api/quick_replies", options);
}
